import { localDay } from "@/lib/studio";
import { computeStreak, dailyTotals } from "@/components/studio/streaks";

export const streakInfo = (hours) => {
  const days = dailyTotals(hours);
  const active = Object.keys(days).filter((k) => days[k] > 0).sort();
  let best = 0, run = 0, prev = null;
  active.forEach((k) => {
    const d = new Date(`${k}T12:00:00`);
    run = prev && Math.round((d - prev) / 864e5) === 1 ? run + 1 : 1;
    best = Math.max(best, run);
    prev = d;
  });
  return { current: computeStreak(hours, 1), best, today: days[localDay(new Date())] || 0, activeDays: active.length };
};
